export default "/images/534d57da5008647b3b2c5ad773467492.avif";